import React from "react";
import TableInvoices from "../../componentes/Tabla/TableInvoices";

export default function InvoiceList() {
  return (
    <TableInvoices />
  )
}